import { injectable, inject } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import withCache from '@framework/with-cache';
import { type IDispatcher } from '@dm-portal/json-rpc-dispatcher';
import DITypes from '@dm-portal/json-rpc-dispatcher/DITypes';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { ITimezone } from '@framework/timezone/vo/Timezone';

@injectable()
class TimeZoneRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) protected readonly rpc: IDispatcher) {
  }

  @withCache
  async getList(): Promise<ITimezone[]> {
    const request = new Request('dm_portal.queries.get_time_zones');
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  }
}

export default TimeZoneRepository;
